/** @format */

import { Component, OnInit, Output, EventEmitter, Input, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { MenuItem, MessageToastOptions, ProblemStatus } from '../../state-management';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { ProblemContact } from 'src/app/models/problem';

@Component({
    selector: 'app-problem-nav',
    templateUrl: './problem-nav.component.html',
    styleUrls: ['./problem-nav.component.scss'],
    standalone: false
})
export class ProblemNavComponent implements OnChanges {
  @Output() statusEmitter = new EventEmitter<string>();
  @Input() menuOption: MenuItem;
  @Input() detailsProblemStatus: string;
  @Input() isCodeCase: boolean;
  @Input() isPermit: boolean;
  //  @Input() disableCC: boolean;
  @Input() assignToMe: boolean;
  @Input() inProgress: boolean;
	@Input() inTransfer: boolean;
  @Input() contacts: ProblemContact[];
	@Input() isCityworksTransferrable: boolean;
	@Input() isCityworksRequest: boolean;
  @Output() reassignEmitter = new EventEmitter<string>();
  @Output() codeCaseEmitter = new EventEmitter<any>();
  @Output() permitEmitter = new EventEmitter<any>();
  @Output() assignToMeEmitter = new EventEmitter<any>();
  @Output() printEmitter = new EventEmitter<any>();
  @Output() saveAsPDFEmitter = new EventEmitter<any>();
  @Output() sendErrorMessageToast = new EventEmitter<MessageToastOptions>();
  @Output() duplicateCaseEmitter = new EventEmitter<any>();
	@Output() convertToCityworksEmitter = new EventEmitter<any>();

  inProgressText: string;
  reporterContactExists: boolean = false;
  availableProblemStatus: ProblemStatus[];

  @ViewChild(NgbDropdown)
  private dropdown: NgbDropdown;

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    if (!!this.contacts) {
			this.reporterContactExists = this.contacts.some(
				(contact) => contact.contactType === 'Reporter' && contact.firstName.length > 0 && contact.lastName.length > 0
      );
    }
    if(changes.menuOption || changes.detailsProblemStatus){
      if(this.menuOption.problemStatusList.length > 0 && this.detailsProblemStatus.length > 0){
        this.availableProblemStatus = this.activeProblemStatusDifferentFromCurrentStatus();
      }
    }
  }

  reassign() {
    this.reassignEmitter.emit();
  }

  emitProblemStatus(status: string) {
    this.statusEmitter.emit(status);
  }

  activeProblemStatusDifferentFromCurrentStatus() {
		return this.menuOption.problemStatusList.filter((s) => s.active && s.problemStatus_Name !== this.detailsProblemStatus);
  }

  getProblemStatusClassName(status: string) {
    // Remove spaces
    const formattedClassName = status.replace(/\s+/g, '');
    return formattedClassName.toLowerCase();
  }

  createCC() {
    this.inProgressText = 'Creating Code Case';
    this.codeCaseEmitter.emit();
  }

  createPermit() {
    if (this.reporterContactExists) {
      this.inProgressText = 'Creating Permit';
      this.permitEmitter.emit();
    } else {
      let errorMessageOptions: MessageToastOptions = {
        type: 'error',
        title: 'Tree permit creation error',
				message: 'Please provide the full name of the reporter contact before creating a tree permit',
      };

      this.sendErrorMessageToast.emit(errorMessageOptions);
    }
  }

  assignToMeClick() {
    this.assignToMeEmitter.emit();
  }

  duplicateCase() {
    this.dropdown.close();
    this.duplicateCaseEmitter.emit();
  }

  print() {
    this.dropdown.close();
    setTimeout(() => {
      this.printEmitter.emit();
    }, 500);
  }

  saveAsPDF() {
    this.inProgressText = 'Profiling Case Summary';
    this.dropdown.close();
    this.saveAsPDFEmitter.emit();
  }

	convertToCityworksProblem() {
		this.inProgressText = 'Transferring Problem To Cityworks';
		this.dropdown.close();
		this.convertToCityworksEmitter.emit();
}
}
